import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const NAV_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'Things to Do', path: '/things-to-do' },
  { label: 'Best Luxury Cabins', path: '/best-luxury-cabins' },
  { label: 'Dog-Friendly Guide', path: '/dog-friendly-highlands-nc' },
  { label: 'Cabins Near Glen Falls', path: '/cabins-near-glen-falls-highlands-nc' },
  { label: 'Cabins in Highlands NC', path: '/cabins-in-highlands-nc' },
  { label: 'Vacation Rentals', path: '/vacation-rentals-highlands-nc' },
  { label: 'Places to Stay', path: '/places-to-stay-highlands-nc' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'bg-white/96 backdrop-blur-md border-b border-[#E5E0D8]' : 'bg-transparent'
      }`}
    >
      <div className="px-6 lg:px-14">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center shrink-0 cursor-pointer">
            <img
              src="https://public.readdy.ai/ai/img_res/0e161647-590e-4d31-89c6-e540141c5b98.png"
              alt="Highlands NC Luxury Cabins Logo"
              className="h-12 w-auto object-contain"
            />
          </Link>

          <div className="hidden md:flex items-center gap-10">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-xs tracking-[0.2em] uppercase font-medium transition-colors duration-300 whitespace-nowrap cursor-pointer ${
                  isActive(link.path)
                    ? scrolled
                      ? 'text-[#2D4A3E] border-b border-[#2D4A3E] pb-0.5'
                      : 'text-white border-b border-white pb-0.5'
                    : scrolled
                    ? 'text-[#5C5850] hover:text-[#2D4A3E]'
                    : 'text-white/85 hover:text-white'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer transition-colors ${
              scrolled ? 'text-[#1A1A18]' : 'text-white'
            }`}
            onClick={() => setMenuOpen((o) => !o)}
            aria-label="Toggle menu"
          >
            <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'} text-2xl`} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-white border-t border-[#E5E0D8] px-8 py-6 flex flex-col gap-5">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-xs tracking-[0.2em] uppercase cursor-pointer transition-colors whitespace-nowrap ${
                isActive(link.path) ? 'text-[#2D4A3E]' : 'text-[#5C5850] hover:text-[#2D4A3E]'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
}